import React from 'react';
import {TeamSession, PlayerSession} from '../../interfaces';
import {Alert, Box} from '@mui/material';
import SessionMetaDataEdit from './SessionMetaDataEdit';
import {isNullOrUndefined} from '../../helpers';
import GameResult from './GameResult';
import {useTranslation} from 'react-i18next';

interface SessionMetaDataProps {
  teamSession?: TeamSession;
  playerSession?: PlayerSession;
  disableEdit?: boolean;
  playerView?: boolean;
}

const SessionMetaData: React.FC<SessionMetaDataProps> = ({
  teamSession,
  playerSession,
  disableEdit,
  playerView,
}) => {
  const {t} = useTranslation();
  const sessionDetail =
    teamSession?.sessionDetail ?? playerSession?.sessionDetail;
  return (
    <>
      {sessionDetail?.locationType &&
      sessionDetail?.opponentName &&
      !isNullOrUndefined(sessionDetail?.teamScore) &&
      !isNullOrUndefined(sessionDetail?.opponentScore) ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            mb: 2,
          }}>
          <Box sx={{display: 'flex', flexDirection: 'row', gap: 2}}>
            <GameResult
              locationType={sessionDetail?.locationType}
              opponentName={sessionDetail?.opponentName}
              teamScore={sessionDetail?.teamScore as number}
              opponentScore={sessionDetail?.opponentScore as number}
              typographyVariant="h4"
            />
          </Box>
          {!disableEdit && (
            <SessionMetaDataEdit
              teamSession={teamSession}
              playerSession={playerSession}
            />
          )}
        </Box>
      ) : (
        <Alert
          severity="info"
          variant="outlined"
          sx={{mb: 2, alignItems: 'center'}}
          action={
            !disableEdit ? (
              <SessionMetaDataEdit
                teamSession={teamSession}
                playerSession={playerSession}
              />
            ) : undefined
          }>
          {disableEdit && playerView
            ? t('general.updateAtTeamSessionLevel')
            : disableEdit
              ? t('general.updateGameDetailsForEachPeriod')
              : t('general.updateGameDetails')}
        </Alert>
      )}
    </>
  );
};

export default SessionMetaData;
